import React, { useState, useEffect } from 'react'
import { Panel, Form, Button, Radio, RadioGroup, Row, Col, Message, ControlLabel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getRequiredData,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import { budgetFormat } from '../../utils/formatterUtil'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import AttachFilesView from '../attachfiles/AttachFilesView'
import { isEmpty } from 'lodash-es'
import { contractCenterApproveCloseOfProject } from '../../redux/actions/closeOfProject'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ClosureAttachmentWidget from '../closureAttachmentWidget/ClosureAttachmentWidget'

export default function CloseProjectContractCenterWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEditAll, isApprove } = props
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [closeTypeSelected, setCloseTypeSelected] = useState(_schema?.closeType?.value)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [uploadError, setUploadError] = useState(false)
  const [deleteError, setDeleteError] = useState()
  const [renameError, setRenameError] = useState()
  const [isErrorFileList, setIsErrorFileList] = useState(false)
  const [approveError, setApproveError] = useState('')

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = {
      projectVersionId: projectId,
      note: data[formSchema.note.name],
      //approveType: data[formSchema.approveType.name] || 0,
    }
    setRequest(request)
    console.log('request', request)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    setApproveError('')
    try {
      const response = await contractCenterApproveCloseOfProject(projectId, request)

      console.log('response', response)
      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        setApproveError('')
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(response.message)
      }
    } catch (e) {
      if (e?.response?.data?.errors?.message) {
        setIsError(e?.response?.data?.errors?.message)
      } else {
        setIsError('บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {/* แนบไฟล์ ปิดโครงการ ตามประเภท (ใหม่) */}
      {formSchema?.closureAttachment && (
        <>
          <br />
          <ClosureAttachmentWidget
            disabledForm={!showCommandButton || formSchema?.closureAttachment.disabled}
            schema={formSchema?.closureAttachment}
            //onUploadSuccess={(e) => setClosureAttachmentNew(e)}
          />
          <br />
        </>
      )}

      {formSchema?.note &&
        (showCommandButton ? (
          <InputForm
            schema={formSchema.note}
            rows={3}
            componentClass="textarea"
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        ) : (
          <>
            <p>{formSchema.note.label}</p>
            <p style={{ textIndent: '2.5em' }}>{formSchema.note.value}</p>
          </>
        ))}

      {showCommandButton && (
        <>
          <hr />

          {isError && <Message showIcon type="error" description={isError} />}

          <SaveButton onClick={handleSubmit(onSubmit)} children={formSchema.buttonText} />
        </>
      )}

      <ConfirmWidget
        // size="sm"
        title={`ยืนยันการ${formSchema.buttonText}`}
        // confirmBtn={`ยืนยัน${formSchema.buttonText}`}
        // cancleBtn={`ยกเลิก${formSchema.buttonText}`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${formSchema.buttonText}`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
